import React, { useEffect, useState } from 'react';
import { Layout, useVersion } from 'react-admin';
import { useHistory, useLocation } from 'react-router-dom';

import { makeStyles } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import { api } from '../../services';
import Menu from './Menu';
import Appbar from './Toolbar';

// O Layout do react-admin usa `min-width: fit-content` no container raiz, e o `.content`
// (item flex ao lado do menu) tem o comportamento padrão de não encolher abaixo do
// conteúdo mínimo. Isso faz a página inteira (incluindo o menu lateral) crescer/rolar na
// horizontal quando alguma tela tem conteúdo largo (ex: uma tabela com muitas colunas ou
// colunas fixadas), em vez da rolagem ficar contida dentro da própria tela. Zerando o
// `min-width` desses dois pontos, a rolagem horizontal passa a ficar restrita a quem
// realmente precisar dela (ex: o wrapper da tabela com `overflow-x: auto`).
const useStyles = makeStyles(() => ({
  root: {
    minWidth: '0 !important',
  },
  content: {
    minWidth: '0 !important',
  },
}));

// Telas liberadas quando o gerencial está bloqueado por documentos pendentes.
const ROTAS_LIBERADAS_NO_BLOQUEIO = ['/minhas-pendencias', '/config_correto'];

const LayoutCustom = (props) => {
  const classes = useStyles();
  const version = useVersion();
  const history = useHistory();
  const { pathname } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [bloqueado, setBloqueado] = useState(false);

  // Bloqueio apenas de interface. Qualquer falha na consulta libera o usuário.
  useEffect(() => {
    let ativo = true;

    async function verificarBloqueio() {
      try {
        const config = await api.get('/config/1');
        let pendente = false;
        if (config.data.bloquear_gerencial_documentos_pendentes) {
          const resumo = await api.get('/documentos/resumo');
          pendente = resumo.data.data.total > 0;
        }
        if (ativo) setBloqueado(pendente);
      } catch (e) {
        if (ativo) setBloqueado(false);
      }
    }

    verificarBloqueio();
    const intervalo = setInterval(verificarBloqueio, 5 * 60 * 1000);
    window.addEventListener('focus', verificarBloqueio);

    return () => {
      ativo = false;
      clearInterval(intervalo);
      window.removeEventListener('focus', verificarBloqueio);
    };
  }, [version]);

  useEffect(() => {
    if (bloqueado && !ROTAS_LIBERADAS_NO_BLOQUEIO.includes(pathname)) {
      history.replace('/minhas-pendencias');
      enqueueSnackbar(
        'Você tem documentos pendentes. Assine ou envie os arquivos para voltar a usar o sistema.',
        { variant: 'warning' },
      );
    }
  }, [bloqueado, pathname]);

  return <Layout {...props} appBar={Appbar} menu={Menu} classes={classes} />;
};

export default LayoutCustom;
